export default __webpack_public_path__ + "static/media/aboutUs-Artwork.5f805a60.svg";